import { rem } from '@app/theme/materialUITheme'
import { Divider, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme: Theme) => ({
  tableContainer: {
    overflow: 'auto',
    padding: '0 20px',
    maxHeight: 220,
    maxWidth: 320,
    margin: '0 auto',
    '@global': {
      '*::-webkit-scrollbar': {
        width: '0.4em',
      },
      '*::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        outline: '1px solid slategrey',
      },
    },
  },
  table: {
    marginTop: 5,
    '& th, & td': {
      padding: 4,
      textAlign: 'center',
      width: '50%',
      fontSize: rem(16),
    },
    '& th': {
      fontWeight: 500,
      color: theme.palette.primary.main,
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    '& td': {
      borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
  },
  ranking: {
    textAlign: 'center',
    fontSize: rem(20),
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  rankingLogo: {
    maxWidth: 200,
    maxHeight: 80,
    margin: '10px auto',
    display: 'block',
  },
}))

interface Props {
  round: TournamentRound
}

const RankingConfig = ({ round }: Props) => {
  const classes = useStyles()

  if (!round.primaryRankingConfig && !round.sideRankingConfig) {
    return null
  }

  return (
    <>
      <Divider style={{ width: '100%', margin: '30px 0' }} />
      <Grid item xs={12}>
        <Typography variant={'h2'} style={{ textAlign: 'center', marginBottom: 16 }}>
          <FormattedMessage id={'strings.ranking'} />
        </Typography>
        <Typography variant="body1" style={{ textAlign: 'center', marginTop: 5, marginBottom: 20 }}>
          <FormattedMessage id="strings.tournamentRankings" />
        </Typography>
        <Grid container spacing={2}>
          {round.primaryRankingName && (
            <Grid item xs={12} sm={round.sideRankingName ? 6 : 12}>
              <Typography
                variant="body1"
                style={{ textAlign: 'center', fontSize: rem(18), fontStyle: 'italic', fontWeight: 500 }}
              >
                <FormattedMessage id="strings.primaryGame" />
              </Typography>
              {round.primaryRankingLogo && (
                <img src={round.primaryRankingLogo.url} className={classes.rankingLogo} alt="" />
              )}
              <Typography variant="body1" className={classes.ranking}>
                <strong>{round.primaryRankingName}</strong>
              </Typography>

              <div className={classes.tableContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <FormattedMessage id="strings.position" />
                      </TableCell>
                      <TableCell>
                        <FormattedMessage id="strings.points" />
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {round.primaryRankingConfig.map((r, i) => (
                      <TableRow key={i}>
                        <TableCell>{r.position}</TableCell>
                        <TableCell>{r.points}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </Grid>
          )}
          {round.sideRankingConfig && (
            <Grid item xs={12} sm={round.primaryRankingName ? 6 : 12}>
              <Typography
                variant="body1"
                style={{ textAlign: 'center', fontSize: rem(18), fontStyle: 'italic', fontWeight: 500 }}
              >
                <FormattedMessage id="strings.sideGame" />
              </Typography>
              {round.sideRankingLogo && <img src={round.sideRankingLogo.url} className={classes.rankingLogo} alt="" />}
              <Typography variant="body1" className={classes.ranking}>
                <strong>{round.sideRankingName}</strong>
              </Typography>

              <div className={classes.tableContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <FormattedMessage id="strings.position" />
                      </TableCell>
                      <TableCell>
                        <FormattedMessage id="strings.points" />
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {round.sideRankingConfig.map((r, i) => (
                      <TableRow key={i}>
                        <TableCell>{r.position}</TableCell>
                        <TableCell>{r.points}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default RankingConfig
